import React, { useCallback, useContext } from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import Button from '../../../button/Button';
import { FuncType } from '../../../button/enum';
import { Size } from '../../../core/enum';
import Dropdown from '../../../dropdown/Dropdown';
import Menu from '../../../menu';
import Switch from '../../../switch/Switch';
import TableContext from '../../TableContext';
import { Placements } from '../../../dropdown/enum';
import { $l } from '../../../locale-context';
const { Item } = Menu;
function findRecords(record, groups) {
    const { parent } = record;
    if (parent) {
        return parent.children || [];
    }
    const fixed = record.get('fixed');
    const group = groups.find(({ value }) => value === fixed);
    if (group) {
        return group.records;
    }
    return [];
}
const ItemSuffix = function ItemSuffix(props) {
    const { record, index, records, groups } = props;
    const { tableStore: { columnHideable, columnTitleEditable, columnDraggable, proPrefixCls: prefixCls } } = useContext(TableContext);
    const changeFixed = useCallback((fixed) => {
        const oldFixed = record.get('fixed');
        const group = groups.find(({ value }) => value === fixed);
        if (group) {
            record.set('sort', group.records.length);
        }
        record.set('fixed', fixed);
        const oldGroup = groups.find(({ value }) => value === oldFixed);
        if (oldGroup) {
            oldGroup.records.filter(r => r !== record).forEach((r, sort) => r.set('sort', sort));
        }
    }, [record, groups]);
    const changeIndex = useCallback((newIndex) => {
        const oldSort = record.get('sort');
        const list = findRecords(record, groups);
        const [removed] = list.splice(oldSort, 1);
        if (removed) {
            list.splice(newIndex, 0, removed);
        }
        list.forEach((r, sort) => r.set('sort', sort));
    }, [record, groups]);
    const handleMenuClick = useCallback(action((arg) => {
        const { key } = arg;
        switch (key) {
            case 'rename':
                record.setState('editing', true);
                break;
            case 'unfixed':
                changeFixed(false);
                break;
            case 'left':
                changeFixed('left');
                break;
            case 'right':
                changeFixed('right');
                break;
            case 'top':
                changeIndex(0);
                break;
            case 'up':
                changeIndex(index - 1);
                break;
            case 'down':
                changeIndex(index + 1);
                break;
            default:
        }
    }), [record, index, changeFixed, changeIndex]);
    const getTreeNodesMenus = useCallback(() => {
        const fixed = record.get('fixed');
        const menus = [];
        if (columnTitleEditable && record.get('titleEditable') !== false) {
            menus.push(React.createElement(Item, { key: "rename" }, $l('Table', 'rename')));
        }
        if (columnDraggable) {
            if (!record.parent) {
                if (fixed) {
                    menus.push(React.createElement(Item, { key: "unfixed" }, $l('Table', 'unlock')));
                }
                else {
                    menus.push(React.createElement(Item, { key: "left" }, $l('Table', 'left_lock')), React.createElement(Item, { key: "right" }, $l('Table', 'right_lock')));
                }
            }
            if (index > 1) {
                menus.push(React.createElement(Item, { key: 'top' }, $l('Table', 'top')));
            }
            if (index > 0) {
                menus.push(React.createElement(Item, { key: "up" }, $l('Table', 'up')));
            }
            if (index < records.length - 1) {
                menus.push(React.createElement(Item, { key: "down" }, $l('Table', 'down')));
            }
        }
        if (menus.length) {
            return (React.createElement(Menu, { prefixCls: `${prefixCls}-dropdown-menu`, onClick: handleMenuClick }, menus));
        }
    }, [record, index, records, columnTitleEditable, columnDraggable, handleMenuClick]);
    const menu = getTreeNodesMenus();
    return (React.createElement(React.Fragment, null,
        menu && (React.createElement(Dropdown, { overlay: menu, placement: Placements.bottomRight },
            React.createElement(Button, { funcType: FuncType.flat, size: Size.small, icon: "more_horiz", className: `${prefixCls}-customization-tree-treenode-hover-button` }))),
        React.createElement(Switch, { record: record, disabled: !columnHideable || record.get('hideable') === false || (record.parent && record.parent.get('hidden')), name: "hidden", value: false, unCheckedValue: true })));
};
ItemSuffix.displayName = 'ItemSuffix';
export default observer(ItemSuffix);
